import React from 'react';

export function Overview() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0494 22C18.8003 20.7295 21.5 17.18 21.5 13C21.5 7.75329 17.2467 3.5 12 3.5C6.75329 3.5 2.5 7.75329 2.5 13C2.5 17.18 5.19968 20.7295 8.95056 22H5.67384C2.8469 20.0093 1 16.7203 1 13C1 6.92487 5.92487 2 12 2C18.0751 2 23 6.92487 23 13C23 16.7203 21.1531 20.0093 18.3262 22H15.0494Z"
            />
            <path d="M4 20.5H20L18 22H6L4 20.5Z" />
            <circle cx="12" cy="13" r="1.5" />
            <path d="M14.1477 9.81202C14.3456 9.63668 14.6458 9.64576 14.8328 9.83273L15.1676 10.1675C15.3544 10.3543 15.3636 10.6542 15.1887 10.8522L12.6735 13.6986C12.4826 13.9146 12.1491 13.9249 11.9453 13.721L11.2827 13.0585C11.079 12.8548 11.0891 12.5216 11.3047 12.3307L14.1477 9.81202Z" />
            <path d="M11 5.5C11 5.22386 11.2239 5 11.5 5H12.5C12.7761 5 13 5.22386 13 5.5V6.5C13 6.77614 12.7761 7 12.5 7H11.5C11.2239 7 11 6.77614 11 6.5V5.5Z" />
            <path d="M19.5 12C19.7761 12 20 12.2239 20 12.5V13.5C20 13.7761 19.7761 14 19.5 14H18.5C18.2239 14 18 13.7761 18 13.5V12.5C18 12.2239 18.2239 12 18.5 12H19.5Z" />
            <path d="M5.5 12C5.77614 12 6 12.2239 6 12.5V13.5C6 13.7761 5.77614 14 5.5 14H4.5C4.22386 14 4 13.7761 4 13.5L4 12.5C4 12.2239 4.22386 12 4.5 12H5.5Z" />
            <path d="M16.8064 6.78361C17.0017 6.58834 17.3183 6.58834 17.5135 6.78361L18.2206 7.49071C18.4159 7.68598 18.4159 8.00256 18.2206 8.19782L17.513 8.90541C17.3178 9.10068 17.0012 9.10068 16.8059 8.90541L16.0988 8.19831C15.9036 8.00304 15.9036 7.68646 16.0988 7.4912L16.8064 6.78361Z" />
            <path d="M7.90645 7.48641C8.10171 7.68167 8.10171 7.99826 7.90645 8.19352L7.19934 8.90063C7.00408 9.09589 6.68749 9.09589 6.49223 8.90063L5.78537 8.19376C5.59011 7.9985 5.59011 7.68192 5.78537 7.48666L6.49248 6.77955C6.68774 6.58429 7.00432 6.58429 7.19958 6.77955L7.90645 7.48641Z" />
        </svg>
    );
}

export function PersonalId() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 4.5V19.5H22.5V4.5H1.5ZM1 3C0.447715 3 0 3.44772 0 4V20C0 20.5523 0.447716 21 1 21H23C23.5523 21 24 20.5523 24 20V4C24 3.44772 23.5523 3 23 3H1Z"
            />
            <path d="M15 13.2C15 13.0895 15.0895 13 15.2 13H19.8C19.9105 13 20 13.0895 20 13.2V14.3C20 14.4105 19.9105 14.5 19.8 14.5H15.2C15.0895 14.5 15 14.4105 15 14.3V13.2Z" />
            <rect x="15" y="9" width="3" height="1.5" rx="0.2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 12.5C9.10457 12.5 10 11.6046 10 10.5C10 9.39543 9.10457 8.5 8 8.5C6.89543 8.5 6 9.39543 6 10.5C6 11.6046 6.89543 12.5 8 12.5ZM8 14C9.933 14 11.5 12.433 11.5 10.5C11.5 8.567 9.933 7 8 7C6.067 7 4.5 8.567 4.5 10.5C4.5 12.433 6.067 14 8 14Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.61537 15.0693C5.03076 15.707 4.75 16.4702 4.75 17H3.25C3.25 16.0298 3.71924 14.918 4.50963 14.0557C5.3163 13.1757 6.50812 12.5 8 12.5C9.49188 12.5 10.6837 13.1757 11.4904 14.0557C12.2808 14.918 12.75 16.0298 12.75 17H11.25C11.25 16.4702 10.9692 15.707 10.3846 15.0693C9.8163 14.4493 9.00812 14 8 14C6.99188 14 6.1837 14.4493 5.61537 15.0693Z"
            />
        </svg>
    );
}

export function Users() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6217 15.2584C19.0488 14.3779 20 12.8 20 11C20 8.23858 17.7614 6 15 6C12.2386 6 10 8.23858 10 11C10 12.8 10.9512 14.3779 12.3783 15.2584C11.2508 15.7056 10.2641 16.4116 9.47219 17.2277C8.12703 18.6138 7.25 20.4163 7.25 22H8.75C8.75 20.917 9.38686 19.4695 10.5486 18.2723C11.6959 17.0901 13.2621 16.25 15 16.25C16.7379 16.25 18.3041 17.0901 19.4514 18.2723C20.6131 19.4695 21.25 20.917 21.25 22H22.75C22.75 20.4163 21.873 18.6138 20.5278 17.2277C19.7359 16.4116 18.7492 15.7056 17.6217 15.2584ZM18.5 11C18.5 12.933 16.933 14.5 15 14.5C13.067 14.5 11.5 12.933 11.5 11C11.5 9.067 13.067 7.5 15 7.5C16.933 7.5 18.5 9.067 18.5 11Z"
            />
            <path d="M13.4352 4.68956C12.6009 3.09114 10.9278 2 8.99989 2C6.23846 2 3.99989 4.23858 3.99989 7C3.99989 8.80001 4.95105 10.3779 6.37817 11.2584C5.25074 11.7056 4.264 12.4116 3.47208 13.2277C2.26668 14.4698 1.43719 16.0463 1.27783 17.5H2.79093C2.94876 16.4963 3.55776 15.2933 4.54853 14.2723C5.61218 13.1763 7.03579 12.3743 8.62255 12.2632C8.54207 11.8546 8.49989 11.4322 8.49989 11C8.49989 10.8207 8.50714 10.6432 8.52138 10.4676C6.81477 10.2342 5.49989 8.77068 5.49989 7C5.49989 5.067 7.06689 3.5 8.99989 3.5C10.2845 3.5 11.4075 4.19207 12.0163 5.2237C12.4617 4.99318 12.9371 4.81265 13.4352 4.68956Z" />
        </svg>
    );
}

export function User() {
    return (
        <svg
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="1" y="1" width="40" height="40" rx="20" fill="white" />
            <path
                d="M28.7337 26.6134C28.3127 25.616 27.7016 24.7101 26.9346 23.946C26.17 23.1797 25.2642 22.5688 24.2672 22.1469C24.2583 22.1424 24.2494 22.1402 24.2404 22.1357C25.6311 21.1313 26.5351 19.4951 26.5351 17.6491C26.5351 14.5911 24.0574 12.1134 20.9994 12.1134C17.9413 12.1134 15.4636 14.5911 15.4636 17.6491C15.4636 19.4951 16.3677 21.1313 17.7583 22.138C17.7494 22.1424 17.7404 22.1447 17.7315 22.1491C16.7315 22.571 15.8342 23.1759 15.0641 23.9482C14.2978 24.7129 13.6869 25.6187 13.265 26.6156C12.8505 27.5916 12.627 28.6381 12.6065 29.6982C12.6059 29.722 12.6101 29.7458 12.6188 29.7679C12.6275 29.7901 12.6406 29.8103 12.6572 29.8274C12.6738 29.8444 12.6937 29.858 12.7157 29.8673C12.7377 29.8765 12.7612 29.8813 12.7851 29.8813H14.1244C14.2226 29.8813 14.3007 29.8031 14.3029 29.7072C14.3476 27.9839 15.0395 26.3701 16.2628 25.1469C17.5284 23.8813 19.2092 23.1848 20.9994 23.1848C22.7895 23.1848 24.4703 23.8813 25.736 25.1469C26.9592 26.3701 27.6511 27.9839 27.6958 29.7072C27.698 29.8054 27.7761 29.8813 27.8744 29.8813H29.2136C29.2375 29.8813 29.2611 29.8765 29.283 29.8673C29.305 29.858 29.3249 29.8444 29.3415 29.8274C29.3582 29.8103 29.3712 29.7901 29.3799 29.7679C29.3886 29.7458 29.3928 29.722 29.3922 29.6982C29.3699 28.6313 29.1489 27.5933 28.7337 26.6134ZM20.9994 21.4884C19.9748 21.4884 19.0105 21.0889 18.2851 20.3634C17.5596 19.638 17.1601 18.6737 17.1601 17.6491C17.1601 16.6246 17.5596 15.6603 18.2851 14.9348C19.0105 14.2094 19.9748 13.8098 20.9994 13.8098C22.0239 13.8098 22.9882 14.2094 23.7136 14.9348C24.4391 15.6603 24.8386 16.6246 24.8386 17.6491C24.8386 18.6737 24.4391 19.638 23.7136 20.3634C22.9882 21.0889 22.0239 21.4884 20.9994 21.4884Z"
                fill="#7F7F7F"
            />
            <rect
                x="1"
                y="1"
                width="40"
                height="40"
                rx="20"
                stroke="#F0F0F1"
                strokeWidth="1.5"
            />
        </svg>
    );
}

export function Logout() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M18.2863 18.5559C18.3684 18.6298 18.3752 18.7564 18.2996 18.837C16.475 20.7837 13.8805 22 11.002 22C5.47911 22 1.00195 17.5228 1.00195 12C1.00195 6.47715 5.47911 2 11.002 2C13.8805 2 16.475 3.21628 18.2996 5.16297C18.3752 5.24358 18.3684 5.37022 18.2863 5.44413L17.4686 6.18C17.3865 6.25388 17.2603 6.24707 17.1845 6.16676C15.6347 4.52478 13.438 3.5 11.002 3.5C6.30753 3.5 2.50195 7.30558 2.50195 12C2.50195 16.6944 6.30753 20.5 11.002 20.5C13.438 20.5 15.6347 19.4752 17.1845 17.8332C17.2603 17.7529 17.3865 17.7461 17.4686 17.82L18.2863 18.5559Z" />
            <path
                d="M18.2863 18.5559C18.3684 18.6298 18.3752 18.7564 18.2996 18.837C16.475 20.7837 13.8805 22 11.002 22C5.47911 22 1.00195 17.5228 1.00195 12C1.00195 6.47715 5.47911 2 11.002 2C13.8805 2 16.475 3.21628 18.2996 5.16297C18.3752 5.24358 18.3684 5.37022 18.2863 5.44413L17.4686 6.18C17.3865 6.25388 17.2603 6.24707 17.1845 6.16676C15.6347 4.52478 13.438 3.5 11.002 3.5C6.30753 3.5 2.50195 7.30558 2.50195 12C2.50195 16.6944 6.30753 20.5 11.002 20.5C13.438 20.5 15.6347 19.4752 17.1845 17.8332C17.2603 17.7529 17.3865 17.7461 17.4686 17.82L18.2863 18.5559Z"
                fill="black"
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.002 12.75H12.202C12.0915 12.75 12.002 12.6605 12.002 12.55V11.45C12.002 11.3395 12.0915 11.25 12.202 11.25H22.002V12.75Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.002 12.75H12.202C12.0915 12.75 12.002 12.6605 12.002 12.55V11.45C12.002 11.3395 12.0915 11.25 12.202 11.25H22.002V12.75Z"
                fill="black"
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9413 12L18.113 9.17175C18.0349 9.09365 18.0349 8.96701 18.113 8.88891L18.8909 8.11109C18.969 8.03299 19.0956 8.03299 19.1737 8.11109L22.9212 11.8586C22.9993 11.9367 22.9993 12.0633 22.9212 12.1414L19.1737 15.8889C19.0956 15.967 18.969 15.967 18.8909 15.8889L18.113 15.1111C18.0349 15.033 18.0349 14.9064 18.113 14.8282L20.9413 12Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9413 12L18.113 9.17175C18.0349 9.09365 18.0349 8.96701 18.113 8.88891L18.8909 8.11109C18.969 8.03299 19.0956 8.03299 19.1737 8.11109L22.9212 11.8586C22.9993 11.9367 22.9993 12.0633 22.9212 12.1414L19.1737 15.8889C19.0956 15.967 18.969 15.967 18.8909 15.8889L18.113 15.1111C18.0349 15.033 18.0349 14.9064 18.113 14.8282L20.9413 12Z"
                fill="black"
                fillOpacity="0.2"
            />
        </svg>
    );
}

export function Settings() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0772 3.53981L14.5354 1.15568C14.5147 1.06462 14.4337 1 14.3403 1H9.65964C9.56626 1 9.48531 1.06462 9.46461 1.15568L8.92276 3.53981C7.92593 3.90248 7.01131 4.4363 6.21442 5.10574L3.87622 4.38213C3.78702 4.35453 3.69058 4.39232 3.64389 4.47319L1.30354 8.52681C1.25685 8.60768 1.27233 8.71009 1.34084 8.77354L3.13547 10.4356C3.04643 10.9437 2.99999 11.4664 2.99999 12C2.99999 12.5336 3.04643 13.0563 3.13547 13.5644L1.34084 15.2265C1.27233 15.2899 1.25685 15.3923 1.30354 15.4732L3.64389 19.5268C3.69058 19.6077 3.78702 19.6455 3.87623 19.6179L6.21442 18.8943C7.01131 19.5637 7.92594 20.0975 8.92276 20.4602L9.46461 22.8443C9.48531 22.9354 9.56626 23 9.65964 23H14.3403C14.4337 23 14.5147 22.9354 14.5354 22.8443L15.0772 20.4602C16.0741 20.0975 16.9887 19.5637 17.7856 18.8943L20.1238 19.6179C20.213 19.6455 20.3094 19.6077 20.3561 19.5268L22.6964 15.4732C22.7431 15.3923 22.7277 15.2899 22.6591 15.2265L20.8645 13.5644C20.9536 13.0563 21 12.5336 21 12C21 11.4664 20.9536 10.9437 20.8645 10.4356L22.6591 8.77354C22.7277 8.71009 22.7431 8.60768 22.6965 8.52681L20.3561 4.47319C20.3094 4.39232 20.213 4.35453 20.1238 4.38213L17.7856 5.10574C16.9887 4.4363 16.0741 3.90248 15.0772 3.53981ZM19.5759 6.12187L17.4473 6.78061L16.8207 6.25426C16.1558 5.6957 15.3937 5.25114 14.5644 4.94942L13.7958 4.66979L13.3027 2.5H10.6973L10.2042 4.66979L9.4356 4.94942C8.60628 5.25114 7.84414 5.6957 7.17925 6.25426L6.55269 6.78061L4.42408 6.12187L3.12142 8.37813L4.75395 9.8901L4.61295 10.6946C4.53883 11.1175 4.49999 11.5536 4.49999 12C4.49999 12.4464 4.53883 12.8825 4.61295 13.3054L4.75395 14.1099L3.12142 15.6219L4.42408 17.8781L6.55269 17.2194L7.17925 17.7457C7.84415 18.3043 8.60628 18.7489 9.4356 19.0506L10.2042 19.3302L10.6973 21.5H13.3027L13.7958 19.3302L14.5644 19.0506C15.3937 18.7489 16.1558 18.3043 16.8207 17.7457L17.4473 17.2194L19.5759 17.8781L20.8786 15.6219L19.246 14.1099L19.387 13.3054C19.4612 12.8825 19.5 12.4464 19.5 12C19.5 11.5536 19.4612 11.1175 19.387 10.6946L19.246 9.8901L20.8786 8.37813L19.5759 6.12187ZM16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51471 16.5 7.49999 14.4853 7.49999 12C7.49999 9.51472 9.51471 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12ZM15 12C15 13.6569 13.6568 15 12 15C10.3431 15 8.99999 13.6569 8.99999 12C8.99999 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0772 3.53981L14.5354 1.15568C14.5147 1.06462 14.4337 1 14.3403 1H9.65964C9.56626 1 9.48531 1.06462 9.46461 1.15568L8.92276 3.53981C7.92593 3.90248 7.01131 4.4363 6.21442 5.10574L3.87622 4.38213C3.78702 4.35453 3.69058 4.39232 3.64389 4.47319L1.30354 8.52681C1.25685 8.60768 1.27233 8.71009 1.34084 8.77354L3.13547 10.4356C3.04643 10.9437 2.99999 11.4664 2.99999 12C2.99999 12.5336 3.04643 13.0563 3.13547 13.5644L1.34084 15.2265C1.27233 15.2899 1.25685 15.3923 1.30354 15.4732L3.64389 19.5268C3.69058 19.6077 3.78702 19.6455 3.87623 19.6179L6.21442 18.8943C7.01131 19.5637 7.92594 20.0975 8.92276 20.4602L9.46461 22.8443C9.48531 22.9354 9.56626 23 9.65964 23H14.3403C14.4337 23 14.5147 22.9354 14.5354 22.8443L15.0772 20.4602C16.0741 20.0975 16.9887 19.5637 17.7856 18.8943L20.1238 19.6179C20.213 19.6455 20.3094 19.6077 20.3561 19.5268L22.6964 15.4732C22.7431 15.3923 22.7277 15.2899 22.6591 15.2265L20.8645 13.5644C20.9536 13.0563 21 12.5336 21 12C21 11.4664 20.9536 10.9437 20.8645 10.4356L22.6591 8.77354C22.7277 8.71009 22.7431 8.60768 22.6965 8.52681L20.3561 4.47319C20.3094 4.39232 20.213 4.35453 20.1238 4.38213L17.7856 5.10574C16.9887 4.4363 16.0741 3.90248 15.0772 3.53981ZM19.5759 6.12187L17.4473 6.78061L16.8207 6.25426C16.1558 5.6957 15.3937 5.25114 14.5644 4.94942L13.7958 4.66979L13.3027 2.5H10.6973L10.2042 4.66979L9.4356 4.94942C8.60628 5.25114 7.84414 5.6957 7.17925 6.25426L6.55269 6.78061L4.42408 6.12187L3.12142 8.37813L4.75395 9.8901L4.61295 10.6946C4.53883 11.1175 4.49999 11.5536 4.49999 12C4.49999 12.4464 4.53883 12.8825 4.61295 13.3054L4.75395 14.1099L3.12142 15.6219L4.42408 17.8781L6.55269 17.2194L7.17925 17.7457C7.84415 18.3043 8.60628 18.7489 9.4356 19.0506L10.2042 19.3302L10.6973 21.5H13.3027L13.7958 19.3302L14.5644 19.0506C15.3937 18.7489 16.1558 18.3043 16.8207 17.7457L17.4473 17.2194L19.5759 17.8781L20.8786 15.6219L19.246 14.1099L19.387 13.3054C19.4612 12.8825 19.5 12.4464 19.5 12C19.5 11.5536 19.4612 11.1175 19.387 10.6946L19.246 9.8901L20.8786 8.37813L19.5759 6.12187ZM16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51471 16.5 7.49999 14.4853 7.49999 12C7.49999 9.51472 9.51471 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12ZM15 12C15 13.6569 13.6568 15 12 15C10.3431 15 8.99999 13.6569 8.99999 12C8.99999 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z"
                fillOpacity="0.2"
            />
        </svg>
    );
}

export function CompanyId() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="2.375" y="12" width="19.25" height="1.5" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 7.5V20.5H21.5V7.5H2.5ZM2 6C1.44772 6 1 6.44772 1 7V21C1 21.5523 1.44772 22 2 22H22C22.5523 22 23 21.5523 23 21V7C23 6.44772 22.5523 6 22 6H2Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5 13.5H9.5V14.5H14.5V13.5ZM8 12V15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15V12H8Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 6H8.5V3.5H15.5V6ZM7 7.5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V7.5H7Z"
            />
        </svg>
    );
}

export function Close() {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M13 3L3 13" strokeWidth="1.5" strokeLinecap="square" />
            <path d="M13 13L3 3" strokeWidth="1.5" strokeLinecap="square" />
        </svg>
    );
}

export function LeftArrow() {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.75 10.4334L4.30705 6L8.75 1.5666L8.18537 1L3.48511 5.7167L3.25 6L3.48511 6.2833L8.18537 11L8.75 10.4334Z"
            />
        </svg>
    );
}

export function RightArrow() {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.25 1.5666L7.69295 6L3.25 10.4334L3.81462 11L8.51489 6.2833L8.75 6L8.51489 5.7167L3.81462 1L3.25 1.5666Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.25 1.5666L7.69295 6L3.25 10.4334L3.81462 11L8.51489 6.2833L8.75 6L8.51489 5.7167L3.81462 1L3.25 1.5666Z"
            />
        </svg>
    );
}
export function HorizontalDots() {
    return (
        <svg
            width="18"
            height="4"
            viewBox="0 0 18 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.382812 2.0918C0.382812 1.61328 0.551432 1.2054 0.888672 0.868164C1.23047 0.530924 1.63835 0.362305 2.1123 0.362305C2.59082 0.362305 2.9987 0.530924 3.33594 0.868164C3.67773 1.2054 3.84863 1.61328 3.84863 2.0918C3.84863 2.57031 3.67773 2.98047 3.33594 3.32227C2.9987 3.65951 2.59082 3.82812 2.1123 3.82812C1.63835 3.82812 1.23047 3.65951 0.888672 3.32227C0.551432 2.98047 0.382812 2.57031 0.382812 2.0918ZM7.29102 2.0918C7.29102 1.61328 7.45964 1.2054 7.79688 0.868164C8.13867 0.530924 8.54655 0.362305 9.02051 0.362305C9.49902 0.362305 9.9069 0.530924 10.2441 0.868164C10.5859 1.2054 10.7568 1.61328 10.7568 2.0918C10.7568 2.57031 10.5859 2.98047 10.2441 3.32227C9.9069 3.65951 9.49902 3.82812 9.02051 3.82812C8.54655 3.82812 8.13867 3.65951 7.79688 3.32227C7.45964 2.98047 7.29102 2.57031 7.29102 2.0918ZM14.1992 2.0918C14.1992 1.61328 14.3678 1.2054 14.7051 0.868164C15.0469 0.530924 15.4548 0.362305 15.9287 0.362305C16.4072 0.362305 16.8151 0.530924 17.1523 0.868164C17.4941 1.2054 17.665 1.61328 17.665 2.0918C17.665 2.57031 17.4941 2.98047 17.1523 3.32227C16.8151 3.65951 16.4072 3.82812 15.9287 3.82812C15.4548 3.82812 15.0469 3.65951 14.7051 3.32227C14.3678 2.98047 14.1992 2.57031 14.1992 2.0918Z"
                fill="#AFAFAF"
            />
        </svg>
    );
}
export function Upload() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.11273 7.05481C8.09937 7.03774 8.08229 7.02393 8.0628 7.01443C8.04331 7.00494 8.02191 7 8.00023 7C7.97855 7 7.95715 7.00494 7.93766 7.01443C7.91817 7.02393 7.90109 7.03774 7.88773 7.05481L5.88773 9.58517C5.87124 9.60622 5.86101 9.63149 5.85821 9.65809C5.8554 9.68468 5.86014 9.71153 5.87188 9.73556C5.88361 9.75959 5.90187 9.77983 5.92457 9.79397C5.94727 9.80812 5.97349 9.81558 6.00023 9.81553L7.43603 9.73556V14.1441C7.43603 14.2227 7.49935 14.287 7.57792 14.287H8.39613C8.4747 14.287 8.53801 14.2227 8.53801 14.1441V9.73556H10C10.1196 9.73556 10.1859 9.67981 10.1127 9.58696L8.11273 7.05481Z"
                fill="#3F2DF3"
            />
            <path
                d="M13.3333 5.55556C12.5154 3.39841 10.4446 2 8.00356 2C5.56249 2 3.48451 3.39841 2.66666 5.55556C1.1363 5.95734 0.222168 7.19665 0.222168 8.85379C0.222168 10.827 1.5982 12.2824 3.56963 12.2824L4.2857 12.3143C4.36427 12.3143 4.44439 12.3008 4.44439 12.2222L4.42856 11.2109C4.42856 11.1324 4.36427 11.0681 4.2857 11.0681H3.56963C2.96785 11.0681 2.40177 10.8288 1.98035 10.3949C1.5607 9.96272 1.33749 9.38058 1.35713 8.77701C1.3732 8.30558 1.53392 7.86272 1.82499 7.48951C2.1232 7.10915 2.54106 6.83237 3.00535 6.70915L3.68213 6.53237L3.93035 5.87879C4.08392 5.47165 4.2982 5.09129 4.56785 4.74665C4.83404 4.40506 5.14937 4.10478 5.50356 3.85558C6.23749 3.33951 7.10177 3.06629 8.00356 3.06629C8.90535 3.06629 9.76963 3.33951 10.5036 3.85558C10.8589 4.10558 11.1732 4.40558 11.4393 4.74665C11.7089 5.09129 11.9232 5.47344 12.0768 5.87879L12.3232 6.53058L12.9982 6.70915C13.9661 6.96987 14.6428 7.85022 14.6428 8.85379C14.6428 9.44487 14.4125 10.002 13.9946 10.4199C13.7897 10.626 13.5459 10.7894 13.2774 10.9007C13.0089 11.0119 12.721 11.0688 12.4303 11.0681H11.7143C11.6357 11.0681 11.5714 11.1324 11.5714 11.2109L11.5555 12C11.5555 12.0786 11.6272 12.2824 11.7058 12.2824H12.4303C14.4018 12.2824 15.7777 10.8621 15.7777 8.88889C15.7777 7.23353 14.8601 5.95913 13.3333 5.55556Z"
                fill="#3F2DF3"
            />
        </svg>
    );
}
export function Upload2() {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.3616 2.2915C10.4276 2.19255 10.573 2.19255 10.639 2.2915L12.8276 5.57437C12.9014 5.68513 12.822 5.83349 12.6889 5.83349H11.1253V14.0002C11.1253 14.0922 11.0507 14.1668 10.9587 14.1668H10.042C9.94994 14.1668 9.87533 14.0922 9.87533 14.0002V5.83349H8.31175C8.17863 5.83349 8.09923 5.68513 8.17307 5.57437L10.3616 2.2915Z"
                fill="white"
            />
            <path
                d="M18.4587 13.3335C18.5507 13.3335 18.6253 13.4081 18.6253 13.5002V17.9585C18.6253 18.0505 18.5507 18.1252 18.4587 18.1252H2.95866C2.86661 18.1252 2.79199 18.0505 2.79199 17.9585V13.5002C2.79199 13.4081 2.86661 13.3335 2.95866 13.3335H3.87533C3.96737 13.3335 4.04199 13.4081 4.04199 13.5002V16.8752H17.3753V13.5002C17.3753 13.4081 17.4499 13.3335 17.542 13.3335H18.4587Z"
                fill="white"
            />
        </svg>
    );
}
export function Trash() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.33325 1.66699V2.66699H9.66659V1.66699H6.33325ZM5.99992 0.666992C5.63173 0.666992 5.33325 0.965469 5.33325 1.33366V3.00033C5.33325 3.36852 5.63173 3.66699 5.99992 3.66699H9.99992C10.3681 3.66699 10.6666 3.36852 10.6666 3.00033V1.33366C10.6666 0.965469 10.3681 0.666992 9.99992 0.666992H5.99992Z"
            />
            <path d="M1.33325 3.00033C1.33325 2.81623 1.48249 2.66699 1.66659 2.66699H14.3333C14.5173 2.66699 14.6666 2.81623 14.6666 3.00033V3.33366C14.6666 3.51775 14.5173 3.66699 14.3333 3.66699H1.66658C1.48249 3.66699 1.33325 3.51775 1.33325 3.33366V3.00033Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.83325 4.66699V14.0003C3.83325 14.0924 3.90787 14.167 3.99992 14.167H11.9999C12.092 14.167 12.1666 14.0924 12.1666 14.0003V4.66699H13.1666V14.0003C13.1666 14.6447 12.6442 15.167 11.9999 15.167H3.99992C3.35559 15.167 2.83325 14.6447 2.83325 14.0003V4.66699H3.83325Z"
            />
        </svg>
    );
}

export function Edit() {
    return (
        <svg
            viewBox="64 64 896 896"
            focusable="false"
            width="1em"
            height="1em"
            fill="currentColor"
        >
            <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path>
        </svg>
    );
}

export function Check() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0403 3.76435C14.1705 3.89453 14.1705 4.10558 14.0403 4.23575L6.23559 12.0405C6.10541 12.1706 5.89436 12.1706 5.76418 12.0405L1.95945 8.23576C1.82927 8.10558 1.82927 7.89453 1.95945 7.76435L2.43085 7.29294C2.56102 7.16277 2.77208 7.16277 2.90225 7.29294L5.99988 10.3905L13.0975 3.29294C13.2277 3.16277 13.4388 3.16277 13.5689 3.29294L14.0403 3.76435Z"
                fill="#1C1C1C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0403 3.76435C14.1705 3.89453 14.1705 4.10558 14.0403 4.23575L6.23559 12.0405C6.10541 12.1706 5.89436 12.1706 5.76418 12.0405L1.95945 8.23576C1.82927 8.10558 1.82927 7.89453 1.95945 7.76435L2.43085 7.29294C2.56102 7.16277 2.77208 7.16277 2.90225 7.29294L5.99988 10.3905L13.0975 3.29294C13.2277 3.16277 13.4388 3.16277 13.5689 3.29294L14.0403 3.76435Z"
                fill="black"
                fillOpacity="0.2"
            />
        </svg>
    );
}

export function HorizontalLine() {
    return (
        <svg
            width="8"
            height="1"
            viewBox="0 0 8 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line y1="0.5" x2="8" y2="0.5" stroke="#1C1C1C" />
            <line y1="0.5" x2="8" y2="0.5" stroke="black" strokeOpacity="0.2" />
        </svg>
    );
}

export function Calendar() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.91699 4.58301V16.2497H17.0837V4.58301H2.91699ZM2.50033 3.33301C2.04009 3.33301 1.66699 3.7061 1.66699 4.16634V16.6663C1.66699 17.1266 2.04009 17.4997 2.50033 17.4997H17.5003C17.9606 17.4997 18.3337 17.1266 18.3337 16.6663V4.16634C18.3337 3.7061 17.9606 3.33301 17.5003 3.33301H2.50033Z"
                fill="#5B5B5B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.0833 8.33301H2.5V7.08301H17.0833V8.33301Z"
                fill="#5B5B5B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.08301 2.08301V5.83301H5.83301V2.08301H7.08301Z"
                fill="#5B5B5B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.167 2.08301V5.83301H12.917V2.08301H14.167Z"
                fill="#5B5B5B"
            />
        </svg>
    );
}
export function Vector() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 14 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.08912 0.333659L7.00033 6.25759L12.9115 0.333659L13.667 1.08649L7.37806 7.35352L7.00033 7.66699L6.62259 7.35352L0.333659 1.08649L1.08912 0.333659Z"
                fill="#7F7F7F"
            />
        </svg>
    );
}
export function LogoSE() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_12214_366004)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M-4.9104 -2.17383H4.91058V5.97463H-4.9104V-2.17383Z"
                    fill="#224B8C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H16V16H0V0Z"
                    fill="#003897"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H16V9.6H0V6Z"
                    fill="#FFCC00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 0H8.6V16H5V0Z"
                    fill="#FFCC00"
                />
            </g>
            <defs>
                <clipPath id="clip0_12214_366004">
                    <path
                        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function LogoNO() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_12214_366010)">
                <path
                    d="M-0.463867 -1.43262H15.1996V17.5304H-0.463867V-1.43262Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H16V16H0V0Z"
                    fill="#CC2229"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.19995 0H8.79995V16H5.19995V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6.2998H16V9.8998H0V6.2998Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 0H8V16H6V0Z"
                    fill="#003897"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 7H16V9H0V7Z"
                    fill="#003897"
                />
            </g>
            <defs>
                <clipPath id="clip0_12214_366010">
                    <path
                        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function LogoFI() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_12214_366015)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H16V16H0V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5.99902H16V9.59902H0V5.99902Z"
                    fill="#003897"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 -0.000976562H8.6V15.999H5V-0.000976562Z"
                    fill="#003897"
                />
            </g>
            <defs>
                <clipPath id="clip0_12214_366015">
                    <path
                        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function LogoDK() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_12214_366020)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 -0.000976562H16V15.999H0V-0.000976562Z"
                    fill="#EA252D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H16V9.6H0V6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 -0.000976562H8.6V15.999H5V-0.000976562Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_12214_366020">
                    <path
                        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function LogoEN() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_58_34180)">
                <g clipPath="url(#clip1_58_34180)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M-13.0039 -29.25H63.9485V63.9808H-13.0039V-29.25Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M60.5535 38.6759V-3.9458H-9.60889V38.6759H60.5535Z"
                        fill="#224B8C"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.4695 18.1914V-3.9458H-9.60889V18.1914H25.4695Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.16596 5.48195V-3.9458H-9.60889V5.48195H6.16596ZM6.16596 8.80044V18.1914H-9.60889V8.80044H6.16596ZM9.69468 5.48195V-3.9458H25.4695V5.48195H9.69468ZM9.69468 8.80044V18.1914H25.4695V8.80044H9.69468Z"
                        fill="#003897"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.788046 5.48194H6.16596V4.37384L-7.12413 -3.9458H-9.60889V-1.06505L0.788046 5.48194Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.4695 8.26112V6.08895H-9.60889V8.26112H25.4695ZM-9.60889 -1.87085V-3.9458L5.22659 5.48194H2.13901L-9.60889 -1.87085Z"
                        fill="#CC2229"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.837947 8.80044H6.16596V10.0498L-5.39949 18.1914H-9.60889V16.072L0.837947 8.80044ZM15.0722 5.48195H9.69468V4.37386L22.9844 -3.9458H25.4695V-1.06504L15.0722 5.48195ZM15.0227 8.80044H9.69468V10.0498L21.2601 18.1914H25.4695V16.072L15.0227 8.80044Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.7644 18.1914L9.69468 8.80044H12.009L25.4695 18.1914H22.7644ZM8.98327 18.1914V-3.9458H6.88935V18.1914H8.98327ZM-6.90416 18.1914L6.16596 8.80044H3.85167L-9.60889 18.1914H-6.90416ZM25.4695 -1.87084V-3.9458L10.6336 5.48195H13.7212L25.4695 -1.87084Z"
                        fill="#CC2229"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M44.282 31.683L44.6134 32.7722L45.5212 32.408L45.0266 33.4015L45.8266 34.0365L44.8793 34.1865L44.9699 35.342L44.282 34.5352L43.595 35.342L43.6856 34.1865L42.7382 34.0365L43.5383 33.4015L43.044 32.408L43.9515 32.7722L44.282 31.683ZM8.88666 24.9005L9.54897 27.0789L11.3634 26.3495L10.375 28.337L11.975 29.6071L10.0799 29.9065L10.2612 32.2179L8.88666 30.6044L7.51174 32.2179L7.69259 29.9065L5.79749 29.6071L7.39796 28.337L6.40909 26.3495L8.22395 27.0789L8.88666 24.9005ZM37.1935 13.8278L37.5248 14.917L38.4318 14.5523L37.9384 15.5458L38.738 16.1808L37.7907 16.3308L37.8813 17.4867L37.1935 16.6795L36.5068 17.4867L36.597 16.3308L35.6489 16.1808L36.4497 15.5458L35.9555 14.5523L36.8621 14.917L37.1935 13.8278ZM44.5463 -0.0725098L44.8777 1.01624L45.7847 0.651547L45.2909 1.64501L46.0909 2.28007L45.1427 2.43001L45.2342 3.58599L44.5463 2.77922L43.8597 3.58599L43.9499 2.43001L43.0017 2.28007L43.8026 1.64501L43.3083 0.651547L44.215 1.01624L44.5463 -0.0725098ZM52.4669 10.5127L52.7982 11.6014L53.7053 11.2372L53.2114 12.2307L54.0115 12.8657L53.0641 13.0152L53.1547 14.1712L52.4669 13.3644L51.7798 14.1712L51.8704 13.0152L50.9223 12.8652L51.7231 12.2307L51.2289 11.2372L52.1355 11.6014L52.4669 10.5127ZM48.8894 20.0183L49.0891 20.7051H49.6803L49.2124 21.1559L49.3785 21.8456L48.8894 21.4412L48.4008 21.8456L48.5669 21.1559L48.099 20.7051H48.6898L48.8894 20.0183Z"
                        fill="white"
                    />
                    <path
                        d="M60.5535 38.6764V-3.9458H-9.60889V38.6764H60.5535V38.6764Z"
                        stroke="black"
                        strokeWidth="6.44597"
                        strokeMiterlimit="2.613"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_58_34180">
                    <rect width="16" height="16" rx="8" fill="white" />
                </clipPath>
                <clipPath id="clip1_58_34180">
                    <rect
                        width="76.9524"
                        height="93.2308"
                        fill="white"
                        transform="translate(-13.0039 -29.25)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function LogoIS() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 512 512"
            style={{ borderRadius: '50%' }}
        >
            <defs>
                <clipPath id="a">
                    <path fillOpacity=".7" d="M85.4 0h486v486h-486z" />
                </clipPath>
            </defs>
            <g
                fillRule="evenodd"
                strokeWidth="0"
                clipPath="url(#a)"
                transform="translate(-90) scale(1.0535)"
            >
                <path fill="#003897" d="M0 0h675v486H0z" />
                <path
                    fill="#fff"
                    d="M0 189h189V0h108v189h378v108H297v189H189V297H0V189z"
                />
                <path
                    fill="#d72828"
                    d="M0 216h216V0h54v216h405v54H270v216h-54V270H0v-54z"
                />
            </g>
        </svg>
    );
}

export function Theme() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 11C7.88071 11 9 9.88071 9 8.5C9 7.11929 7.88071 6 6.5 6C5.11929 6 4 7.11929 4 8.5C4 9.88071 5.11929 11 6.5 11ZM6.5 9.5C7.05228 9.5 7.5 9.05228 7.5 8.5C7.5 7.94772 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.94772 5.5 8.5C5.5 9.05228 5.94772 9.5 6.5 9.5Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.2 3C1.08954 3 1 3.08954 1 3.2V20.8C1 20.9105 1.08954 21 1.2 21H22.8C22.9105 21 23 20.9105 23 20.8V3.2C23 3.08954 22.9105 3 22.8 3H1.2ZM2.5 17.0596V19.5H21.5V16.5417L21.4913 16.5511L15.5408 11.0583L9.09015 18.0052L5.02449 14.9559L2.5 17.0596ZM2.5 15.1071L4.73249 13.2467C4.87492 13.128 5.08024 13.1227 5.22856 13.234L8.90984 15.9949L15.1879 9.23398C15.3379 9.07243 15.5903 9.06271 15.7523 9.21224L21.5 14.5178V4.5H2.5V15.1071Z"
            />
        </svg>
    );
}
export function Eye() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="anticon anticon-eye ant-input-password-icon"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 12.0001C24 13.0001 19 21 12.0001 21C5.00011 21 0 13.0001 0 12.0001C0 11 5 3 12.0001 3C19.0001 3 24 11 24 12.0001ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                fill="#1C1C1C"
            />
        </svg>
    );
}
export function EyeClose() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="anticon anticon-eye-invisible ant-input-password-icon"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5657 2.84852C22.6438 2.77042 22.6438 2.64379 22.5657 2.56568L21.4343 1.43431C21.3562 1.35621 21.2296 1.35621 21.1515 1.43431L17.7722 4.8136C16.0921 3.74727 14.1395 3 12.0001 3C5 3 0 11 0 12.0001C0 12.5894 1.73632 15.6094 4.595 17.9908L1.43431 21.1515C1.35621 21.2296 1.35621 21.3562 1.43431 21.4343L2.56568 22.5657C2.64379 22.6438 2.77042 22.6438 2.84852 22.5657L22.5657 2.84852ZM8.55382 14.032L14.032 8.55382C13.4365 8.20193 12.7418 8 12 8C9.79086 8 8 9.79086 8 12C8 12.7418 8.20193 13.4365 8.55382 14.032Z"
                fill="#1C1C1C"
            />
            <path
                d="M12 16C11.8908 16 11.7827 15.9956 11.6757 15.987L7.67668 19.9861C8.99803 20.6077 10.45 21 12.0001 21C19 21 24 13.0001 24 12.0001C24 11.4966 22.7329 9.21915 20.5813 7.08142L15.987 11.6757C15.9956 11.7827 16 11.8908 16 12C16 14.2091 14.2091 16 12 16Z"
                fill="#1C1C1C"
            />
        </svg>
    );
}

export function Insurance() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6424_963)">
                <path d="M4.5 2.5V20.5L9 20.499V22H4C3.44772 22 3 21.5523 3 21V2C3 1.44772 3.44772 1 4 1H19C19.5523 1 20 1.44772 20 2V10.999H18.5V2.5H4.5Z" />
                <rect
                    x="7.375"
                    y="5.375"
                    width="9.25"
                    height="0.75"
                    strokeWidth="0.75"
                />
                <rect
                    x="7.375"
                    y="9.375"
                    width="4.25"
                    height="0.75"
                    strokeWidth="0.75"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 20.5V21.5H19.5V20.5H12.5ZM12 19C11.4477 19 11 19.4477 11 20V23H21V20C21 19.4477 20.5523 19 20 19H12Z"
                />
                <rect x="15.5" y="17.5" width="1" height="1" stroke="#7F7F7F" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 16.5C16.8284 16.5 17.5 15.8284 17.5 15C17.5 14.1716 16.8284 13.5 16 13.5C15.1716 13.5 14.5 14.1716 14.5 15C14.5 15.8284 15.1716 16.5 16 16.5ZM16 18C17.6569 18 19 16.6569 19 15C19 13.3431 17.6569 12 16 12C14.3431 12 13 13.3431 13 15C13 16.6569 14.3431 18 16 18Z"
                />
            </g>
            <defs>
                <clipPath id="clip0_6424_963">
                    <rect width="24" height="24" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function Statistic() {
    return (
        <svg
            className="icon"
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3 20.75C21.4105 20.75 21.5 20.6605 21.5 20.55V19.45C21.5 19.3395 21.4105 19.25 21.3 19.25H2.25L2.25 0.2C2.25 0.0895435 2.16046 0 2.05 0H0.95C0.839543 0 0.75 0.0895431 0.75 0.2V20.55C0.75 20.6605 0.839542 20.75 0.949999 20.75H21.3Z"
            />
            <path d="M4.67176 13.889L9.00001 9.56072L12.3586 12.9193C12.4367 12.9974 12.5633 12.9974 12.6414 12.9193L20.8889 4.67181C20.967 4.5937 20.967 4.46707 20.8889 4.38897L20.1111 3.61115C20.033 3.53304 19.9064 3.53304 19.8283 3.61115L12.5 10.9394L9.14143 7.58082C9.06332 7.50271 8.93669 7.50271 8.85859 7.58082L3.6111 12.8283C3.53299 12.9064 3.53299 13.033 3.6111 13.1111L4.38892 13.889C4.46702 13.9671 4.59365 13.9671 4.67176 13.889Z" />
        </svg>
    );
}

export function Comment() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.39677 15.8293L3.76779 20.2322L8.17069 19.6032L8.56404 19.7773C9.61276 20.2414 10.7742 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.2258 3.75856 14.3873 4.22269 15.436L4.39677 15.8293ZM2.85102 16.043C2.3039 14.8068 2 13.4389 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.5611 22 9.19323 21.6961 7.957 21.149L3.31995 21.8114C2.65999 21.9057 2.0943 21.34 2.18858 20.6801L2.85102 16.043Z"
            />
            <circle cx="7" cy="12" r="1" fill="#1C1C1C" />
            <circle cx="12" cy="12" r="1" fill="#1C1C1C" />
            <circle cx="17" cy="12" r="1" fill="#1C1C1C" />
        </svg>
    );
}

export function Plus() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
    );
}
export function QuestionMark() {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 17C11.5523 17 12 16.5523 12 16C12 15.4477 11.5523 15 11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17Z"
                fill="#1C1C1C"
            />
            <path
                d="M11 6C9.3458 6 8 7.36716 8 9.04762C8 9.46842 8.33577 9.5 8.75 9.5C9.16422 9.5 9.5 9.46842 9.5 9.04762C9.5 8.20739 10.1729 7.52381 11 7.52381C11.8271 7.52381 12.6113 8.20739 12.6113 9.04762C12.6113 10 12 10.5 11 11C10.7764 11.1118 10.25 11.2698 10.25 12V13.5769C10.25 13.9977 10.5858 14 11 14C11.4142 14 11.75 13.9977 11.75 13.5769V12.1687C11.75 11.9545 14 10.9524 14 9C14 7.31954 12.6542 6 11 6Z"
                fill="#1C1C1C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
                fill="#1C1C1C"
            />
        </svg>
    );
}

export function FAQ() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M13.9265 15.7528C14.2309 15.7528 14.4863 15.6496 14.6926 15.4432C14.899 15.2369 15.0021 14.9815 15.0021 14.6771C15.0021 14.3728 14.899 14.1174 14.6926 13.9111C14.4863 13.7047 14.2309 13.6015 13.9265 13.6015C13.6222 13.6015 13.3668 13.7047 13.1605 13.9111C12.9541 14.1174 12.8509 14.3728 12.8509 14.6771C12.8509 14.9815 12.9541 15.2369 13.1605 15.4432C13.3668 15.6496 13.6222 15.7528 13.9265 15.7528ZM13.2167 12.2008H14.6364C14.6524 11.6399 14.7089 11.234 14.8062 10.983C14.9034 10.732 15.1504 10.4264 15.5471 10.0663C15.9344 9.72369 16.2989 9.34722 16.6407 8.93689C16.9825 8.52657 17.1534 8.00828 17.1534 7.38203C17.1534 6.49763 16.8525 5.77855 16.2508 5.2248C15.649 4.67105 14.8743 4.39417 13.9265 4.39417C13.219 4.39417 12.5784 4.59097 12.0048 4.98457C11.4311 5.37817 11.012 5.92615 10.7475 6.62852L12.0286 7.18123C12.1976 6.7207 12.4466 6.37012 12.7756 6.12951C13.1047 5.88888 13.4883 5.76856 13.9265 5.76856C14.4531 5.76856 14.8859 5.92114 15.225 6.22631C15.5641 6.53147 15.7336 6.92148 15.7336 7.39635C15.7336 7.85529 15.5671 8.25328 15.234 8.59032C14.901 8.92735 14.5464 9.26557 14.1704 9.605C13.7943 9.9476 13.5413 10.2998 13.4115 10.6615C13.2816 11.0232 13.2167 11.5363 13.2167 12.2008ZM6.85135 19.1469C6.29186 19.1469 5.81895 18.9538 5.43262 18.5674C5.04627 18.1811 4.8531 17.7081 4.8531 17.1487V2.99828C4.8531 2.43879 5.04627 1.96587 5.43262 1.57952C5.81895 1.19318 6.29186 1 6.85135 1H21.0017C21.5612 1 22.0341 1.19318 22.4205 1.57952C22.8068 1.96587 23 2.43879 23 2.99828V17.1487C23 17.7081 22.8068 18.1811 22.4205 18.5674C22.0341 18.9538 21.5612 19.1469 21.0017 19.1469H6.85135ZM6.85135 17.5311H21.0017C21.0974 17.5311 21.185 17.4913 21.2647 17.4116C21.3444 17.3319 21.3842 17.2443 21.3842 17.1487V2.99828C21.3842 2.90266 21.3444 2.815 21.2647 2.73531C21.185 2.65563 21.0974 2.6158 21.0017 2.6158H6.85135C6.75573 2.6158 6.66808 2.65563 6.5884 2.73531C6.50871 2.815 6.46886 2.90266 6.46886 2.99828V17.1487C6.46886 17.2443 6.50871 17.3319 6.5884 17.4116C6.66808 17.4913 6.75573 17.5311 6.85135 17.5311ZM2.99825 23C2.43878 23 1.96587 22.8068 1.57952 22.4205C1.19317 22.0341 1 21.5612 1 21.0017V5.23558H2.6158V21.0017C2.6158 21.0974 2.65563 21.185 2.73531 21.2647C2.815 21.3444 2.90265 21.3842 2.99825 21.3842H18.7644V23H2.99825Z" />
        </svg>
    );
}

export function HolderDots() {
    return (
        <svg
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="2" cy="2" r="2" fill="#AFAFAF" />
            <circle cx="10" cy="2" r="2" fill="#AFAFAF" />
            <circle cx="2" cy="10" r="2" fill="#AFAFAF" />
            <circle cx="10" cy="10" r="2" fill="#AFAFAF" />
            <circle cx="2" cy="18" r="2" fill="#AFAFAF" />
            <circle cx="10" cy="18" r="2" fill="#AFAFAF" />
        </svg>
    );
}

export function Contact() {
    return (
        <svg
            className="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_3076_34601"
                maskUnits="userSpaceOnUse"
                x="0"
                y="2"
                width="19"
                height="14"
            >
                <path d="M0 2H19V7.5H15L14.5 8V16H0V2Z" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3076_34601)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 3.5V14.5H17.5V3.5H1.5ZM1 2C0.447715 2 0 2.44772 0 3V15C0 15.5523 0.447716 16 1 16H18C18.5523 16 19 15.5523 19 15V3C19 2.44772 18.5523 2 18 2H1Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.34 8.5L0.52 3.64L1.48 2.36L9.3 7.22C9.37111 7.27333 9.46889 7.27333 9.54 7.22L17.52 2.36L18.48 3.64L10.5 8.5C9.86 8.98 8.98 8.98 8.34 8.5Z"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 8.5V21.5H22.5V8.5H15.5ZM15 7C14.4477 7 14 7.44772 14 8V22C14 22.5523 14.4477 23 15 23H23C23.5523 23 24 22.5523 24 22V8C24 7.44772 23.5523 7 23 7H15Z"
            />
            <circle cx="19" cy="19.5" r="1" />
        </svg>
    );
}
